<script lang="ts">
  import { Col, Row } from 'sveltestrap';
  import { ColoredRibbons, Dummytext, Ribbon } from '../../../utils/Constant/Constant';
  import Card from '../../Core/Card.svelte';
  let Ribbondata = [1,2,3]
</script>

<Col sm="12" xl="12">
  <Card headerTitle={ColoredRibbons}>
    <div slot="customheader">
      <span>{'use class'} <code>{'.Ribbon-colored .bg-primary'}</code></span> 
    </div>
    <div slot="contentbody">
      <Row>
        {#each Ribbondata as item}
            <Col sm="12" lg="4" md="6">
              <div class="card ribbon-wrapper">
                <div class="card-body">
                  <div class="ribbon ribbon-primary ribbon-space-bottom">{Ribbon}</div>
                    <p>{Dummytext}</p>
                </div>
              </div>
            </Col>
        {/each}
      </Row>
    </div>
  </Card>
</Col>
